import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { useAuthStore } from '@/shared/auth/auth-store';

const RTL_LANGS = new Set(['ar', 'he', 'fa', 'ur']);

const fallbackLng = (import.meta.env.VITE_DEFAULT_LOCALE as string) || 'ar';

void i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // Default to Arabic if nothing is detected; do NOT fall through to English
    // values when an Arabic key is missing — show the key fallback supplied at
    // call site instead.
    fallbackLng,
    supportedLngs: ['ar', 'en', 'fr', 'es'],
    load: 'languageOnly',
    debug: import.meta.env.DEV,
    interpolation: { escapeValue: false },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      // Cache-bust translations across deploys so users always pick up new
      // strings on every reload.
      queryStringParams: { v: import.meta.env.PROD ? '__APP_VERSION__' : String(Date.now()) },
    },
    detection: {
      order: ['querystring', 'localStorage', 'htmlTag', 'navigator'],
      caches: ['localStorage'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'elshahd_locale',
    },
    react: { useSuspense: true },
  });

i18n.on('languageChanged', (lng) => {
  const rtl = RTL_LANGS.has(lng);
  document.documentElement.lang = lng;
  document.documentElement.dir = rtl ? 'rtl' : 'ltr';
  useAuthStore.getState().setLocale(lng, rtl);
});

export { i18n };
